<div class="content">
  <div class="login">
    <div class="login-logo-odm">
      <img src="{{logoPath}}">
    </div>
    <form (ngSubmit)="sendEmail(forgetPasswordForm)" #forgetPasswordForm="ngForm">
      <div class="login-content">
        <h3><span>{{'Resend Activation Mail' | translate}}</span>{{'We will send activation mail to your registered account.' | translate}}</h3>
        <div class="form-group">
          <label for="" class="col-form-label" translate>E-mail</label>
          <div>
            <input type="text" pInputText class="pInputText" [(ngModel)]="loginEmail" name="loginEmail" required
                   pattern="^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" #emailAccount="ngModel">
            <p-message severity="error" text="Email is invalid" *ngIf="(forgetPasswordForm.submitted && !emailAccount.dirty) || (emailAccount.invalid && (emailAccount.dirty || emailAccount.touched))">
            </p-message>
          </div>
        </div>
        <ng-container *ngIf="recaptcha.render">
<!--          <re-captcha siteKey="6LelXNYZAAAAAJ5830oP9rdWaOxCxVQuTrSta9si"></re-captcha>-->
          <p-captcha siteKey="6LelXNYZAAAAAJ5830oP9rdWaOxCxVQuTrSta9si"></p-captcha>
          <p-message severity="error" text="Captcha code provided is incorrect." *ngIf="captchaError"></p-message>
        </ng-container>
        <button type="submit" pButton label="{{'RESEND ACTIVATION MAIL' | translate}}" class="login-btn" name="submit"></button>
      </div>
    </form>
  </div>
</div>



<!-- Resend -->
<p-dialog header="{{'Information' | translate}}" [(visible)]="displayResendDialog" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog">
  <div class="dialog-content">
    <p>{{Msg | translate}}</p>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="closeDialog();" label="{{'OK' | translate}}" class="login-btn"></button>
  </ng-template>
</p-dialog>
